import { path } from 'ramda';

export const hasActiveSession = (state) =>
  path(['appState', 'activeSession'], state);
